import { Box, styled } from '@mui/material';

/** A compact pill: one line of text, a thin border instead of a shadow, so a row of them stays light. */
export const ChipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 0.5, 0.5, 1),
  borderRadius: theme.spacing(4),
  border: `1px solid ${theme.vars.palette.outline.variant}`,
  backgroundColor: theme.palette.background.paper,
  maxWidth: theme.spacing(80)
}));

export const ChipLabel = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flexGrow: 1,
  minWidth: 0
}));
